goog.provide('el8.appchart.dialog.deleteChart');

goog.require('el8.service.pageunload');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.dialog.deleteChart');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.util.amplitude.helpers');

el8.appchart.dialog.deleteChart = (function() {

    var that = new el8.uiwidget.NewDialog({
        title: 'Delete Patient Chart',
        modal: true,
        width: 350,
        autoHeight: true,
        contentFn: function() {
            return el8.template.appchart.dialog.deleteChart.content();
        }
    });
    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'delete-chart', 'Delete Chart', function() {
            if (el8Globals.FEATURES.NewDemographics) {
                el8.util.amplitude.logEvent('Demographics - delete chart');
            }
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('deleteChart'),
                success: function() {
                    el8.service.pageunload.clearLoginRequired(); // don't do last-minute saves on a deleted patient
                    window.location.href = el8.service.urls.get('goToPracticeHome');
                }
            });
        }, true
    );
    buttonSet.addButton(
        'cancel-delete', 'Cancel', function() {
            that.hide();
        }, false
    );
    that.setButtonSet(buttonSet);

    return that;

})();
